import { FiAlertCircle, FiClock } from "react-icons/fi";
import styles from "./TrialStatus.module.scss";

const TONE_ICONS = {
  info: FiClock,
  warning: FiClock,
  danger: FiAlertCircle,
};

const TrialStatusChip = ({ chip, onClick, expanded = false, className = "" }) => {
  if (!chip) return null;
  const Icon = TONE_ICONS[chip.tone] || FiClock;

  return (
    <button
      type="button"
      className={`${styles.chip} ${styles[`chip--${chip.tone}`]} ${className}`}
      onClick={onClick}
      aria-haspopup="dialog"
      aria-expanded={expanded}
    >
      <Icon className={styles.chipIcon} aria-hidden="true" />
      {chip.label}
    </button>
  );
};

export default TrialStatusChip;
